<template>
  <div>
    <h2>Invited ({{ invitations.length }}) <v-icon color="pfxBrand" class="pointer" @click="viewInviteForm = !viewInviteForm">add</v-icon></h2>
    <v-data-table :headers="headers" :items="invitations" must-sort hide-actions item-key="id" v-if="invitations.length > 0">
      <template slot="no-data">
        No pending invitations
      </template>
      <template slot="items" slot-scope="props">
        <tr class="pointer">
          <td>
            {{ props.item.created | prettyDateTime }}
          </td>
          <td>
            {{ props.item.email }}
          </td>
          <td>
            <small>{{ props.item.token }}</small>
          </td>
          <td align="right">
            <div>
              <button class="btn-danger btn-small" @click.prevent="deleteInvitation(props.item.token)"><v-icon dark>delete</v-icon> Delete</button>
              <button class="btn-neutral btn-small" @click.prevent="resendInvitation(props.item.token, props.item.email)"><v-icon dark>email</v-icon> Resend</button>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <form ref="inviteForm" class="clearfix" style="margin: 1rem 2rem 1rem;" v-if="viewInviteForm">
      <fieldset class="col12">
        <input v-model.trim="email" id="email" type="email" required="required" placeholder="Email address" />
      </fieldset>
      <fieldset class="col12">
        <button class="btn-small" @click.prevent="invite"><v-icon dark>email</v-icon> Send new invitation</button>
      </fieldset>
    </form>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'TenantMembersInvite',
  props: {
    inviteRoleValue: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      viewInviteForm: false,
      invitations: [],
      email: '',
      headers: [
        { text: 'Created', align: 'left', value: 'created' },
        { text: 'Email', align: 'left', value: 'email' },
        { text: 'Invitation token', align: 'left', value: 'token' },
        { text: 'Actions', align: 'right', sortable: false },
      ]
    }
  },
  created() {
    const role = this.inviteRoleValue
    this.$PfxBackendApi
      .getPendingInvitations(
        this.subdomain,
        this.idToken
      )
      .then(res => {
        console.info('getPendingInvitations res', res)
        this.invitations = res.data
        this.invitations = this.invitations.filter(function(invite) {
          return invite.role === role
        })
      })
      .catch(err => {
        console.error('getPendingInvitations err', err)
        this.$notify({ type: 'danger', message: 'Cannot fetch data about pending invitations' })
      })
  },
  methods: {
    ...mapMutations([
      'setLoadingSpinner',
      'openDialog'
    ]),
    invite() {
      const role = this.inviteRoleValue
      if (!this.$refs.inviteForm.checkValidity()) {
        this.$refs.inviteForm.reportValidity()
        return
      }
      let text = ''
      this.setLoadingSpinner(true)
      this.$PfxBackendApi
        .createInvitation(this.email, role)
        .then(res => {
          this.email = ''
          this.invitations.push(res.data)
          text = 'Invitation sent to ' + res.data.email
        })
        .catch(err => {
          console.error('createInvitation err', err)
          text = 'Failed: '
          if (err.status === 400) {
            text += err.data[0] // we happen to know that validation messages come in as an array
          } else {
            text += err.data.message
          }
        })
        .then(() => {
          this.viewInviteForm = false
          this.setLoadingSpinner(false)
          this.openDialog({
            text: text,
            buttons: [{ title: 'Close this' }]
          })
        })
    },
    resendInvitation(token, email) {
      let text = ''
      this.setLoadingSpinner(true)
      this.$PfxBackendApi
        .resendInvitation(token)
        .then(() => {
          text = 'Invitation re-sent to ' + email
        })
        .catch(err => {
          console.error('resendInvitation err', err)
          text = 'Failed: ' + err.data.message
        })
        .then(() => {
          this.setLoadingSpinner(false)
          this.openDialog({
            text: text,
            buttons: [{ title: 'Close this' }]
          })
        })
    },
    deleteInvitation(token) {
      let text = ''
      this.setLoadingSpinner(true)
      this.$PfxBackendApi
        .deleteInvitation(token)
        .then(() => {
          text = 'Invitation deleted'
          this.invitations = this.invitations.filter(i => {
            return i.token !== token
          })
        })
        .catch(err => {
          console.error('deleteInvitation err', err)
          text = 'Failed: ' + err.data.message
        })
        .then(() => {
          this.setLoadingSpinner(false)
          this.openDialog({
            text: text,
            buttons: [{ title: 'Close this' }]
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import 'node_modules/jeet/scss/index';

  .col12 { @include column(1/2); }
  .col13 { @include column(1/3); }

</style>



// WEBPACK FOOTER //
// src/components/TenantMembersInvite.vue